// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","713":"component---src-templates-using-dsg-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"77746d96b6b799a32194","713":"8905b536daef71f43b25","883":"7a851ee2ae0b781cb6ab"}[chunkId] + ".js";
};